module.exports = __webpack_public_path__ + "static/media/sewer-system-bg.93d96049.jpg";